<a
	ucImpression
	[attr.href]="uni().external_url"
	(click)="onKeywordClick()"
	(onImpression)="onKeywordImpression($event)"
	rel="noopener sponsored"
	target="_blank"
	class="block px-5 py-4 -mx-5 border bg-uc-blue-50 border-uc-blue-200 sm:-mx-0 sm:rounded-lg sm:flex sm:items-center sm:justify-between sm:w-full sm:gap-4 lg:flex-nowrap"
>
	<span>
		<span class="block mb-2 text-lg font-semibold flex-shrink-1 text-uc-blue-900">
			{{ uni().title | ucEntities }}
		</span>

		<span class="block text-sm text-gray-600">
			{{ uni().description | ucEntities }}
		</span>
	</span>

	<!-- fake button -->
	<span class="hidden sm:inline-block blue-button focus:outline-none whitespace-nowrap">
		Visit Website
	</span>
</a>
